import { render, staticRenderFns } from "./BloodPressureWithSelfieVideo.vue?vue&type=template&id=f2fb9e7e&lang=pug&"
import script from "./BloodPressureWithSelfieVideo.vue?vue&type=script&lang=js&"
export * from "./BloodPressureWithSelfieVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports